module.exports = __webpack_public_path__ + "static/media/matilde-special-adventour-thinking.8b70651e.png";